import React from 'react';
import { bool, func, string } from 'prop-types';
import { intlShape } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';
import { map } from 'ramda';

import {
  ModalContent,
  ModalHeader,
  ModalBody,
} from '../../../components/ModalSwimmy';
import css from '../CompleteListingDataModal.css';
import { FieldBoolean, FieldSelect, Form, PrimaryButton } from '../../';
import { required } from '../../../util/validators';
import { getOverLookedEditListing } from '../../../marketplace-custom-config';
import { FormattedMessage } from '../../../util/reactIntl';

const CompleteListingDataModalOverLookForm = props => {
  const {
    onUpdateListing,
    updateInProgress,
    updateListingError,
    listingId,
    intl,
  } = props;

  const heading = intl.formatMessage({ id: 'EditListingForm.CompleteListingDataTitle' });
  const requiredMessage = intl.formatMessage({ id: 'Marketplace.requiredMessage' });
  const selectPlaceholder = intl.formatMessage({ id: 'EditListingInformationForm.selectPlaceholder' });
  const handleSubmit = (values) => {
    const {
      overLooked,
      naturistAllowed,
      burkiniAllowed,
    } = values;
    const updatedValues = {
      id: listingId,
      publicData: {
        overLooked,
        naturistAllowed,
        burkiniAllowed,
      },
    };
    onUpdateListing('', updatedValues);
  };

  return (
    <ModalContent className={css.modalContent}>
      <ModalHeader className={css.modalHeader} heading={heading} />
      {/*<ModalCloseButton className={css.modalCloseButton} handleClose={() => setIsOpen(false)} />*/}
      <ModalBody className={css.modalBody}>
        <FinalForm
          initialValues={{}}
          onSubmit={handleSubmit}
          onChange={Function.prototype}
          ready
          render={fieldRenderProps => {
            const {
              handleSubmit,
            } = fieldRenderProps;
            const errorMessage = updateListingError ? (
              <p className={css.error}>
                <FormattedMessage id="EditListingPoliciesForm.updateFailed" />
              </p>
            ) : null;
            return (
              <Form onSubmit={handleSubmit}>
                <FieldSelect
                  className={css.formField}
                  id="overLooked"
                  name="overLooked"
                  label={intl.formatMessage({ id: 'EditListingForm.OverLookedLabel' })}
                  validate={required(requiredMessage)}
                >
                  <option value="">{selectPlaceholder}</option>
                  {map(({ label, key }) => (
                    <option value={key}>{label}</option>
                  ), getOverLookedEditListing(intl))}
                </FieldSelect>
                <FieldBoolean
                  className={css.formField}
                  id="naturistAllowed"
                  name="naturistAllowed"
                  label={intl.formatMessage({ id: 'EditListingForm.NaturismAllowedLabel' })}
                  variant="button"
                  validate={required(requiredMessage)}
                />
                <FieldBoolean
                  className={css.formField}
                  id="burkiniAllowed"
                  name="burkiniAllowed"
                  label={intl.formatMessage({ id: 'EditListingForm.BurkiniAllowedLabel' })}
                  variant="button"
                  validate={required(requiredMessage)}
                />
                {errorMessage}
                <div className={css.buttonContainer}>
                  <PrimaryButton
                    className={css.submitButton}
                    type="submit"
                    inProgress={updateInProgress}
                    disabled={updateInProgress}
                    // ready={submitReady}
                  >
                    {intl.formatMessage({ id: 'Marketplace.save' })}
                  </PrimaryButton>
                </div>
              </Form>
            );
          }}
        />
      </ModalBody>
    </ModalContent>
  );
};

CompleteListingDataModalOverLookForm.propTypes = {
  onCompleteListingDataModalClose: func.isRequired,
  onUpdateListing: func.isRequired,
  updateInProgress: bool,
  listingId: string,
  intl: intlShape.isRequired,
};

export default CompleteListingDataModalOverLookForm;
